import clsx from "clsx";

export const cx = (...inputs) => clsx(inputs);

// 2px ink outline (light ink in dark mode) for keyboard focus. Colours with an
// opacity modifier (`ring-primary/45`) emit no CSS here, so use these instead.
export const focusRing =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-text";
// Drawn inside the element, for rows in scrolling lists and menus that would
// clip an outside ring.
export const focusRingInset =
  "focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-text";

export const surfaceStyles = {
  data: "surface-data shape-control",
  card: "surface-card shape-card",
  panel: "surface-panel shape-card",
  popover: "surface-popover shape-card",
  modal: "surface-modal shape-modal",
  nav: "surface-nav shape-card",
  hero: "surface-hero shape-hero",
  toast: "surface-toast shape-control",
  alert: "surface-alert shape-control",
};

export const controlStyles = {
  input: `ui-input ${focusRing} disabled:cursor-not-allowed disabled:opacity-60`,
  inputDense: `ui-input ui-input-dense ${focusRing} disabled:cursor-not-allowed disabled:opacity-60`,
  select: `ui-select ${focusRing} disabled:cursor-not-allowed disabled:opacity-60`,
  selectDense: `ui-select ui-select-dense ${focusRing} disabled:cursor-not-allowed disabled:opacity-60`,
  textarea: `ui-textarea ${focusRing} disabled:cursor-not-allowed disabled:opacity-60`,
  textareaDense: `ui-textarea ui-textarea-dense ${focusRing} disabled:cursor-not-allowed disabled:opacity-60`,
  pill: "ui-pill",
  pillSubtle: "ui-pill ui-pill-subtle",
  tab: `ui-tab ${focusRing}`,
  menuItem: `ui-menu-item ${focusRingInset}`,
  menuItemCompact: `ui-menu-item ui-menu-item-compact ${focusRingInset}`,
  iconButton: `ui-icon-button ${focusRing}`,
  iconButtonSm: `ui-icon-button ui-icon-button-sm ${focusRing}`,
};

const buttonVariants = {
  primary: "ui-button-primary",
  secondary: "ui-button-secondary",
  subtle: "ui-button-subtle",
  ghost: "ui-button-ghost",
  danger: "ui-button-danger",
};

const buttonSizes = {
  sm: "min-h-[2.25rem] px-3 text-sm",
  md: "min-h-[2.5rem] px-4 text-sm",
  lg: "min-h-[2.75rem] px-5 text-base",
  icon: "h-10 w-10 px-0",
};

const buttonShapes = {
  "control-sm": "shape-control-sm",
  control: "shape-control",
  card: "shape-card",
  pill: "shape-pill",
};

export function getButtonClassName({
  variant = "primary",
  size = "md",
  shape = "control",
  className,
} = {}) {
  return cx(
    "ui-button-base",
    focusRing,
    buttonVariants[variant] || buttonVariants.primary,
    buttonSizes[size] || buttonSizes.md,
    buttonShapes[shape] || buttonShapes.control,
    className,
  );
}
